import { Path } from "@react-pdf/renderer";
import tinycolor from "tinycolor2";

const getSVGPathFromPoints = (points) => {
  let path = "";
  points.forEach((point, index) => {
    if (index === 0) {
      path += `M ${point[0]} ${point[1]} `;
    } else {
      path += `L ${point[0]} ${point[1]} `;
    }
  });
  path += "Z";
  return path;
};

export default function PdfPolygon({ points, backgroundColor }) {
  let color = tinycolor(backgroundColor);
  let alpha = color.getAlpha();
  let hex = color.toHexString();

  return (
    <Path fillOpacity={alpha} fill={hex} d={getSVGPathFromPoints(points)} />
  );
}
